// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_2x230","smallLinkTypography":"_2mNFk","titleTypography":"Q3Dub","cardTitleTypography":"_3UUzA","truncate":"_38T2G","base":"_1TGXR","tip":"_23Bd3"};


//////////////////
// WEBPACK FOOTER
// ./src/views/AccountsAndLoans/components/BankTransfer/BankTransfersList.scss
// module id = 2486
// module chunks = 0